// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__3uQXl","errorLogs":"styles_errorLogs__gxyJY"};